module.exports = __webpack_public_path__ + "static/media/phone_icon.b7596002.jpg";